// @ts-nocheck
let productAtc = document.querySelectorAll(".WI_defautlAtc");

if (!productAtc) {
  console.log("Default add to cart button is not there ❌");
} else {
 productAtc.forEach(p => {
   p.addEventListener('click', async (e)=>{
    let varId = p.getAttribute("data-varid");
    let lodingSpiner = p.querySelector('.WI_loadingSpiner');
    let defaultAtc_text = p.querySelector('.WI_defautlAtc_text');
    defaultAtc_text.style.display = "none";
    lodingSpiner.style.display = "block";
    let formData = {
      'items': [{
        'id': varId,
        'quantity': 1
        }]
    };    
    try {
      const productDefaultAtc = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      document.dispatchEvent(new CustomEvent('updateCart',{bubbles: true}));
      lodingSpiner.style.display = "none";
      defaultAtc_text.style.display = "block";
    } catch (error) {
      console.log("Product add to cart error" + error);
    }
 }); 
 }); 
}

